import React from 'react';
import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: "Dental Implants", href: "/dental-implants" },
  { label: "Dental Implant Cost", href: "/dental-implant-cost" },
  { label: "All-on-4 Implants", href: "/all-on-x" },
  { label: "Snap-in vs Fixed Implant Teeth", href: "/snap-in-dentures" },
  { label: "Mini Dental Implants", href: "/mini-dental-implants" },
  { label: "Tooth Extractions", href: "/tooth-extractions" },
  { label: "Cosmetic Dentistry", href: "/cosmetic-dentistry" },
  { label: "Invisalign", href: "/invisalign" },
  { label: "Emergency Dentistry", href: "/emergency-dentistry" },
  { label: "General Dentistry", href: "/general-dentistry" },
  { label: "Same-Day Crowns", href: "/same-day-crowns" },
  { label: "Sedation Dentistry", href: "/sedation-dentistry" },
  { label: "Bone Grafting", href: "/bone-grafting" },
  { label: "Dental Implants FAQ", href: "/dental-implants-faq" },
];

const resourceLinks = [
  { label: "Meet Dr. Gjelaj", href: "/meet-the-doctor" },
  { label: "Patient Results", href: "/our-results" },
  { label: "Financing Options", href: "/financing-options" },
  { label: "Dental Insurance", href: "/resources/dental-insurance" },
  { label: "Patient Education", href: "/patient-education" },
  { label: "Implant Cost in Florida (2026)", href: "/dental-implant-cost-florida" },
  { label: "Medicare & Implant Coverage", href: "/does-medicare-cover-dental-implants" },
  { label: "Implants vs. Dentures", href: "/dental-implants-vs-dentures" },
  { label: "Do Implants Hurt?", href: "/do-dental-implants-hurt" },
  { label: "Too Old for Implants?", href: "/too-old-for-dental-implants" },
  { label: "Blog", href: "/blog" },
  { label: "Patient Reviews", href: "/patient-reviews" },
];

const localAreaLinks = [
  { label: "Dentist in Trinity, FL", href: "/trinity-fl" },
  { label: "New Port Richey, FL", href: "/new-port-richey-fl" },
  { label: "Dental Implants New Port Richey", href: "/dental-implants-new-port-richey-fl" },
  { label: "Palm Harbor, FL", href: "/palm-harbor-fl" },
  { label: "Tarpon Springs, FL", href: "/tarpon-springs-fl" },
  { label: "Holiday, FL", href: "/holiday-fl" },
  { label: "Port Richey, FL", href: "/port-richey-fl" },
  { label: "Hudson, FL", href: "/hudson-fl" },
  { label: "Odessa, FL", href: "/odessa-fl" },
  { label: "Land O' Lakes, FL", href: "/land-o-lakes-fl" },
  { label: "Wesley Chapel, FL", href: "/wesley-chapel-fl" },
  { label: "Lutz, FL", href: "/lutz-fl" },
  { label: "Spring Hill, FL", href: "/spring-hill-fl" },
  { label: "Zephyrhills, FL", href: "/zephyrhills-fl" },
];

export default function InternalLinksSection() {
  return (
    <section className="py-14 bg-slate-50 border-t border-slate-100">
      <div className="container mx-auto px-6 lg:px-12 max-w-6xl">
        <h2 className="text-2xl font-light text-slate-700 mb-8 text-center">
          Explore <span className="font-serif italic text-amber-700">Trinity Dental Arts</span>
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-4">Our Services</h3>
            <ul className="space-y-2">
              {serviceLinks.map(link => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-amber-700 hover:text-amber-800 hover:underline text-sm font-medium"
                  >
                    → {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-4">Resources & Info</h3>
            <ul className="space-y-2">
              {resourceLinks.map(link => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-amber-700 hover:text-amber-800 hover:underline text-sm font-medium"
                  >
                    → {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-4">Areas We Serve</h3>
            <ul className="space-y-2">
              {localAreaLinks.map(link => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-amber-700 hover:text-amber-800 hover:underline text-sm font-medium"
                  >
                    → {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
